module.exports = __webpack_public_path__ + "img/Team-Wilde-Pracht-1220.66353835.jpg";